import { api } from '../api/client';
import { EmptyState, ErrorState, Loading } from '../components/states';
import { useAsync } from '../hooks/useAsync';
import { useT } from '../i18n/I18nProvider';

interface DriftRecord {
  id: string;
  deviceId: string;
  resourceType: string;
  resourceKey: string;
  classification: string;
  policy: string;
}

export function DriftPage(): JSX.Element {
  const t = useT();
  const { data, error, loading, reload } = useAsync(() => api.get<DriftRecord[]>('/drift'), []);

  const resolve = (id: string, policy: string) => () =>
    void api.post(`/drift/${id}/resolve`, { policy }).then(reload);

  return (
    <section>
      <div className="page-head">
        <h1>{t('drift.title')}</h1>
      </div>
      {loading ? (
        <Loading />
      ) : error ? (
        <ErrorState message={error.message} onRetry={reload} />
      ) : !data || data.length === 0 ? (
        <EmptyState hint={t('drift.empty')} />
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Resource</th>
                <th>{t('drift.classification')}</th>
                <th>{t('drift.policy')}</th>
                <th aria-label="actions" />
              </tr>
            </thead>
            <tbody>
              {data.map((d) => (
                <tr key={d.id}>
                  <td>
                    {d.resourceType}/{d.resourceKey}
                  </td>
                  <td>
                    <span className={`chip chip--${d.classification.toLowerCase()}`}>
                      {d.classification}
                    </span>
                  </td>
                  <td>{d.policy}</td>
                  <td className="row-actions">
                    <button
                      type="button"
                      className="btn btn--ghost"
                      onClick={resolve(d.id, 'AUTO_REPAIR')}
                    >
                      {t('drift.autoRepair')}
                    </button>
                    <button
                      type="button"
                      className="btn btn--ghost"
                      onClick={resolve(d.id, 'IMPORT')}
                    >
                      {t('drift.import')}
                    </button>
                    <button
                      type="button"
                      className="btn btn--ghost"
                      onClick={resolve(d.id, 'APPROVE')}
                    >
                      {t('drift.approve')}
                    </button>
                    <button
                      type="button"
                      className="btn btn--ghost"
                      onClick={resolve(d.id, 'IGNORE')}
                    >
                      {t('drift.ignore')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
